import * as _ from "lodash";
import http from "../constant/api";

export const profileFormService = {
  readProfileFormByProfileId: async (profileId) => {
    const result = await http.get(`/api/profile-form/read/profile-id/${profileId}`);

    return result;
  },
  addProfileForm: async (data) => {
    const result = await http.post(`/api/profile-form/add`, data);

    return result;
  },
  editProfileForm: async (id, data) => {
    const result = await http.put(`/api/profile-form/${id}/edit`, data);

    return result;
  },
  removeProfileForm: async (id) => {
    const result = await http.delete(`/api/profile-form/${id}/remove`);

    return result;
  },
};
